import { render, staticRenderFns } from "./restricted-acl-list.vue?vue&type=template&id=08a1be64&scoped=true&"
import script from "./restricted-acl-list.vue?vue&type=script&lang=js&"
export * from "./restricted-acl-list.vue?vue&type=script&lang=js&"
import style0 from "./restricted-acl-list.vue?vue&type=style&index=0&id=08a1be64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1be64",
  null
  
)

export default component.exports